var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"article-progress"}},[_c('iframe',{ref:"iframe",staticStyle:{"height":"100vh"},attrs:{"src":_vm.siteUrl,"frameborder":"0","width":"100%"},on:{"load":_vm.iframeLoaded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }